import React from 'react'
import { InfoTooltip } from '../../../../common/InfoTooltip'
import { MoreOptionsButton } from '../../../Buttons/MoreOptionsButton'
import type { ReactFlowNodeData } from '../../../../../types/mindmap-components'
import {
  HeaderContainer,
  HeaderRow,
  IconTitleGroup,
  CategoryTitle,
  HeaderActionsGroup,
  SubheadingContainer,
} from '../styles/BaseNodeStyles'

interface NodeHeaderProps {
  icon: React.ComponentType<{ size: number; color: string; strokeWidth?: number }>
  iconColor: string
  categoryLabel: string
  categoryDescription?: string
  categorySubheading?: string
  nodeData: ReactFlowNodeData
  nodeId: string
  isRootNode: boolean
  hasChildren: boolean
  isReadOnly: boolean
  onDeleteNode: (id: string) => void
  onNavigateToReport?: () => void
  onCollapse?: () => void
  renderHeaderActions?: () => React.ReactNode
}

export const NodeHeader = React.memo(
  ({
    icon: CategoryIconComponent,
    iconColor,
    categoryLabel,
    categoryDescription,
    categorySubheading,
    nodeData,
    nodeId,
    isRootNode,
    hasChildren: _,
    isReadOnly,
    onDeleteNode,
    onNavigateToReport,
    onCollapse,
    renderHeaderActions,
  }: NodeHeaderProps) => (
    <HeaderContainer $isCollapsed={false}>
      <HeaderRow $isCollapsed={false}>
        {/* Left side - Category label (display only) */}
        <IconTitleGroup $isCollapsed={false}>
          <CategoryIconComponent size={16} color={iconColor} />
          <CategoryTitle>{categoryLabel}</CategoryTitle>
          {categoryDescription && <InfoTooltip title={categoryDescription} placement="top" />}
        </IconTitleGroup>

        {/* Right side - More options dropdown (with delete options) and custom header actions */}
        <HeaderActionsGroup>
          {!isReadOnly && (
            <MoreOptionsButton
              nodeData={nodeData}
              nodeId={nodeId}
              isRootNode={isRootNode}
              onDelete={onDeleteNode}
              onNavigateToReport={onNavigateToReport}
              onCollapse={onCollapse}
              className="nodrag"
              size={14}
              phase={nodeData.category === 'idea' ? nodeData.phase : undefined}
              branchType={nodeData.category === 'idea' ? nodeData.branchType : undefined}
              branchReasoning={nodeData.category === 'idea' ? nodeData.branchReasoning : undefined}
            />
          )}
          {renderHeaderActions && renderHeaderActions()}
        </HeaderActionsGroup>
      </HeaderRow>
      {/* Subheading */}
      {categorySubheading && <SubheadingContainer>{categorySubheading}</SubheadingContainer>}
    </HeaderContainer>
  )
)
